// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateCustomServerGroupMutationVariables = Types.Exact<{
  serverGroupId: Types.Scalars["ID"]["input"];
  name: Types.Scalars["String"]["input"];
  description?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  matchRules?: Types.InputMaybe<
    Array<Types.ServerGroupMatchRuleInput> | Types.ServerGroupMatchRuleInput
  >;
}>;

export type UpdateCustomServerGroupMutation = {
  __typename?: "Mutation";
  updateServerGroup: {
    __typename?: "UpdateServerGroupPayload";
    errors: Array<string>;
    serverGroup: {
      __typename?: "ServerGroup";
      id: string;
      name: string;
      description?: string | null;
      permittedToEdit: boolean;
      matchRules: Array<{
        __typename?: "ServerGroupMatchRule";
        id: string;
        matchType: Types.ServerGroupMatchTypeEnum;
        matchKey?: string | null;
        pattern: string;
      }>;
    };
  };
};

export const UpdateCustomServerGroupDocument = gql`
  mutation UpdateCustomServerGroup(
    $serverGroupId: ID!
    $name: String!
    $description: String
    $matchRules: [ServerGroupMatchRuleInput!]
  ) {
    updateServerGroup(
      serverGroupId: $serverGroupId
      name: $name
      description: $description
      matchRules: $matchRules
    ) {
      errors
      serverGroup {
        id
        name
        description
        permittedToEdit
        matchRules {
          id
          matchType
          matchKey
          pattern
        }
      }
    }
  }
`;
export type UpdateCustomServerGroupMutationFn = Apollo.MutationFunction<
  UpdateCustomServerGroupMutation,
  UpdateCustomServerGroupMutationVariables
>;

/**
 * __useUpdateCustomServerGroupMutation__
 *
 * To run a mutation, you first call `useUpdateCustomServerGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomServerGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomServerGroupMutation, { data, loading, error }] = useUpdateCustomServerGroupMutation({
 *   variables: {
 *      serverGroupId: // value for 'serverGroupId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      matchRules: // value for 'matchRules'
 *   },
 * });
 */
export function useUpdateCustomServerGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomServerGroupMutation,
    UpdateCustomServerGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCustomServerGroupMutation,
    UpdateCustomServerGroupMutationVariables
  >(UpdateCustomServerGroupDocument, options);
}
export type UpdateCustomServerGroupMutationHookResult = ReturnType<
  typeof useUpdateCustomServerGroupMutation
>;
export type UpdateCustomServerGroupMutationResult =
  Apollo.MutationResult<UpdateCustomServerGroupMutation>;
export type UpdateCustomServerGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomServerGroupMutation,
  UpdateCustomServerGroupMutationVariables
>;
